var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('MPGroup', {
    staticClass: "mp-shops",
    attrs: {
      "prop": _vm.data.template.prop,
      "data": _vm.data.dataSource.data
    }
  }, [_c('MPRowSlider', {
    staticClass: "mp-shops__slider",
    attrs: {
      "list": _vm.data.dataSource.data.shop || [],
      "one-slide-per-view-on-mobile": "",
      "hide-overlay-on-mobile": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var _vm$data$dataSource$d, _el$brand, _el$brand$image, _el$brand$image2, _el$brand$image3, _el$brand2, _el$brand3;

        var el = _ref.el,
            index = _ref.index;
        return [_c('div', {
          staticClass: "mp-shops__shop-card",
          class: {
            'mp-shops__shop-card_last': ((_vm$data$dataSource$d = _vm.data.dataSource.data.shop) === null || _vm$data$dataSource$d === void 0 ? void 0 : _vm$data$dataSource$d.length) && index === _vm.data.dataSource.data.shop.length - 1
          }
        }, [_c('GGLink', {
          staticClass: "shop-card__top",
          attrs: {
            "to": el.path,
            "title": ("Страница магазина " + ((_el$brand = el.brand) === null || _el$brand === void 0 ? void 0 : _el$brand.name))
          }
        }, [el.brand ? _c('img', {
          staticClass: "shop-card__logo",
          attrs: {
            "src": (_el$brand$image = el.brand.image) === null || _el$brand$image === void 0 ? void 0 : _el$brand$image.x1,
            "srcset": ((_el$brand$image2 = el.brand.image) === null || _el$brand$image2 === void 0 ? void 0 : _el$brand$image2.x2) && (((_el$brand$image3 = el.brand.image) === null || _el$brand$image3 === void 0 ? void 0 : _el$brand$image3.x2) + " 2x"),
            "alt": ("Логотип магазина " + ((_el$brand2 = el.brand) === null || _el$brand2 === void 0 ? void 0 : _el$brand2.name))
          }
        }) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "shop-card__name-wrapper"
        }, [_c('p', {
          staticClass: "shop-card__name"
        }, [_vm._v(_vm._s((_el$brand3 = el.brand) === null || _el$brand3 === void 0 ? void 0 : _el$brand3.name))]), _vm._v(" "), _c('p', {
          staticClass: "shop-card__category"
        }, [_vm._v("\n            " + _vm._s(_vm.getCategoryList(el.category)) + "\n          ")]), _vm._v(" "), _c('MPRatingBlock', {
          staticClass: "shop-card__rate",
          attrs: {
            "rate": el.rate,
            "review-count": el.reviewCount
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "shop-card__status",
          class: ("shop-card__status_" + (el.status.status))
        }, [_vm._v("\n          " + _vm._s(el.status.text) + "\n        ")])]), _vm._v(" "), _c('div', {
          staticClass: "shop-card__offers"
        }, _vm._l(el.product, function (product, productIndex) {
          var _product$image, _product$image2;

          return _c('GGLink', {
            key: productIndex,
            staticClass: "shop-card__offer-link",
            attrs: {
              "to": product.path
            }
          }, [_c('div', {
            staticClass: "shop-card__offer"
          }, [_c('div', {
            staticClass: "offer__image-wrap"
          }, [_c('img', {
            staticClass: "offer__image",
            attrs: {
              "src": (_product$image = product.image) === null || _product$image === void 0 ? void 0 : _product$image.x1,
              "srcset": ((_product$image2 = product.image) === null || _product$image2 === void 0 ? void 0 : _product$image2.x2) && ((product.image.x2) + " 2x"),
              "alt": ("Фото товара " + (product.name))
            }
          })]), _vm._v(" "), _c('p', {
            staticClass: "offer__name"
          }, [_vm._v(_vm._s(product.name))])])]);
        }), 1)], 1)];
      }
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }